import { ChevronItemProps } from "./chevron-item.types";

export const ChevronItem = ({
  title,
  icon,
  disabled = false,
  ...props
}: ChevronItemProps) => {
  return (
    <button
      {...props}
      disabled={disabled}
      className={`relative inline-flex items-center ${
        title === "Next" ? "rounded-r-md" : "rounded-l-md"
      }  px-2 py-2 text-gray-400 ring-1 ring-inset ring-zinc-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:ring-zinc-100 disabled:hover:bg-white`}
    >
      <span className="sr-only">{title}</span>
      {icon}
    </button>
  );
};
